import { createSourcesConfig, generateSourceSections, getSourceDisplayName } from 'chatspot-core/utils/sourcesUtils';
// TODO: This is a temporary mapping to the library data format.
// Once backend returns the sources list section, we can remove this mapping.
const getDomainFromUrl = url => {
  try {
    return new URL(url).hostname;
  } catch (_unused) {
    return url;
  }
};

/**
 * Convert Citation to the data format expected by the ai-rendering-library
 */
const mapCitationToLibraryData = citation => {
  // Map to the expected library format based on citation type
  switch (citation.__typename) {
    case 'com.hubspot.copilot.tools.results.citations.WebPageCitation':
      return {
        id: citation.id,
        title: citation.title,
        url: citation.url,
        domain: getDomainFromUrl(citation.url),
        source: 'WEBSITE',
        __typename: 'com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceData'
      };
    case 'com.hubspot.copilot.tools.results.citations.DashworksCitation':
      return {
        id: citation.id,
        title: citation.title,
        url: citation.url || '',
        appName: citation.source,
        description: citation.title,
        source: 'APP',
        __typename: 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData'
      };
    case 'com.hubspot.copilot.tools.results.citations.CrmCitation':
      return {
        id: citation.id,
        title: citation.title,
        url: citation.url || '',
        objectTypeId: citation.objectTypeId || '0-1',
        // Default to contact object type
        objectId: citation.objectId || citation.id,
        source: 'CRM_OBJECT',
        __typename: 'com.hubspot.chatspot.message.schemas.sections.sources.CrmObjectSourceData'
      };
    default:
      // Fallback for unknown types
      return {
        id: citation.id,
        title: citation.title,
        url: '',
        appName: 'Unknown',
        description: citation.title,
        source: 'APP',
        __typename: 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData'
      };
  }
};

/**
 * Convert SourceConfig to MappedSourceType expected by ai-rendering-library
 */
const convertSourceConfigToMappedSource = sourceConfig => {
  const {
    source
  } = sourceConfig;
  const mappedData = mapCitationToLibraryData(source);
  return {
    id: source.id,
    primaryText: sourceConfig.primaryText || source.title,
    secondaryText: sourceConfig.secondaryText || getSourceDisplayName(source),
    data: mappedData
  };
};

/**
 * Groups citations by source type and creates MappedSourceSection array
 */
export const createSourcesSections = citations => {
  if (!citations || citations.length === 0) {
    return [];
  }
  const sourceConfigs = createSourcesConfig(citations);
  const sourceSections = generateSourceSections(sourceConfigs);
  return sourceSections.map(section => ({
    title: section.title,
    sources: section.sources.map(convertSourceConfigToMappedSource)
  }));
};

/**
 * Creates a SourcesListResponseSection from citations
 */
export const createSourcesListResponseSection = (citations, sectionId) => {
  if (!citations || citations.length === 0) {
    return [];
  }
  const sourcesSections = createSourcesSections(citations);
  return [{
    id: sectionId || 'sources-list',
    type: 'SOURCES_LIST',
    sourcesSections,
    sections: sourcesSections,
    // For backward compatibility
    expandable: true,
    expanded: false
  }];
};